import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { redirectToSso, refreshAccessToken } from "../../utils/authentication";
import { getLocalStorageItem } from "../../utils/storage";
import axios from "axios";
import { API_ENDPOINTS } from "../../utils/constants";
import { API_KEY, API_KEY_HEADER } from "../../utils/constants";
import { authAxiosInstance } from "../../utils/axiosInstance";

const config = {
	headers: {
		[API_KEY_HEADER]: API_KEY,
	},
};

const ProtectedRoute = () => {
	const token = getLocalStorageItem("ACCESS_TOKEN");
	const [isTokenValid, setIsTokenValid] = useState(false);

	async function checkTokenValidity() {
		setIsTokenValid(true);
		// try {
		// 	// const response = await authAxiosInstance.post(`${API_ENDPOINTS.CHECK_ACCESS_TOKEN_VALIDITY}`, { 
		// 	// 	token: token,
		// 	// 	isAdmin: true,
		// 	// 	email: getLocalStorageItem("E_MAIL"), 
		// 	// }, config);
		// 	if (true){
		// 		setIsTokenValid(true);
		// 	}
		// 	// }else if (response?.data?.error?.message === "access token invalid but refresh token is valid"){
		// 	// 	const isRefreshTokenValid = await refreshAccessToken();
		// 	// 	if (isRefreshTokenValid) {
		// 	// 		setIsTokenValid(true);
		// 	// 	}
		// 	// }else if (response?.data?.error?.message === "tokens are invalid"){
		// 	// 	redirectToSso();
		// 	// }
		// } catch (error) {
		// 	console.log(error);
		// }
	}

	useEffect(() => {
		if (!token) {
			redirectToSso();
		}else{
			checkTokenValidity();
		}
	}, []);

	return isTokenValid ? <Outlet /> : null;
};

export default ProtectedRoute;